<template>
    <div class="home-admin">
        <heading title="Super Admin Dashboard"/>
        <div class="row">
            <div class="col-sm-6">
                <div class="card card__dashboard-admin">
                    <h3 class="card-header">Users</h3>
                    <div class="card-body">
                        <ul>
                            <li>
                                <router-link to="/user/list">Manage Users</router-link>
                            </li>
                        </ul>
                        <h3>Invitations</h3>
                        <ul>
                            <li>
                                <router-link to="/programadmin/invite">Invite a program admin</router-link>
                            </li>
                            <li>
                                <router-link to="/projectmanager/invite">Invite a project manager</router-link>
                            </li>
                            <li>
                                <router-link to="/ownersrepresentative/invite">Invite an owner's representative
                                </router-link>
                            </li>
                            <li>
                                <router-link to="/auditor/invite">Invite an auditor</router-link>
                            </li>
                            <li>
                                <router-link to="/equipmentowner/invite">Invite an equipment owner</router-link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="card card__dashboard-admin">
                    <h3 class="card-header">Admin Functions</h3>
                    <div class="card-body">
                        <ul>
                            <li>
                                <router-link :to="{name: 'userlogList'}">Log Records</router-link>
                            </li>
                        </ul>

                        <h3>Manage Data</h3>
                        <ul>
                            <li>
                                <router-link to="/equipment/list">Equipment</router-link>
                            </li>
                            <li>
                                <router-link to="/exemption/list">Exemption Requests</router-link>
                            </li>
                            <li>
                                <router-link to="/registration/list">Registrations</router-link>
                            </li>
                            <li>
                                <router-link to="/agency/list">Agencies</router-link>
                            </li>
                            <li>
                                <router-link to="/project/list">Projects</router-link>
                            </li>
                            <li>
                                <router-link to="/company/list">Companies</router-link>
                            </li>
                            <li>
                                <router-link to="/rental/list">Rentals</router-link>
                            </li>
                            <li>
                                <router-link to="/rentalcompany/list">Rental Companies</router-link>
                            </li>
                        </ul>
                        <h3>Config</h3>
                        <ul>
                            <li>
                                <router-link :to="{name: 'helpList'}">Help Messages</router-link>
                            </li>
                            <li>
                                <router-link :to="{name: 'introList'}">Intro Paragraphs</router-link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

    </div>

</template>

<script>

import Vue from 'vue'

/**
 * Home page for global admins
 */
export default Vue.extend({
    name: 'HomeAdmin',
})
</script>

<style lang="scss">

.home-admin {
    max-width: 1440px;
    margin: 0 auto;
}

@media (max-width: 500px) {
    .home-admin {
        .btn {
            width: 100%;
        }
    }
}

@media (max-width: 1000px) {
    .home-admin {
        .btn {
            margin-bottom: 1em;
        }
    }
}

</style>
